import { Routes } from '@angular/router';
import { authGuard, checkAbandoneOrNoAddressdUser, maintenanceGuard, checkMembershipPermissions, checkNoPaymentMethodUser, maintenanceOffGuard } from './shared/guards/auth-guard.guard';
import { productsResolver } from './resolvers/shop.resolver';

export const routes: Routes = [
  {
    path: 'maintenance',
    title: 'Maintenance',
    loadComponent: () => import('./maintenance/maintenance.component').then(m => m.MaintenanceComponent),
    canActivate: [maintenanceOffGuard]
  },
  {
    path: 'ecommerce-admin/:token',
    title: 'Ecommerce Admin',
    loadComponent: () => import('./authentication/ecommerce-admin/ecommerce-admin.component').then(m => m.EcommerceAdminComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'login',
    title: 'Log In',
    loadComponent: () => import('./authentication/login/login.component').then(m => m.LoginComponent),
    canActivate: [maintenanceGuard, authGuard]
  },
  {
    path: 'signup',
    title: 'Sign Up',
    loadComponent: () => import('./authentication/signup/signup.component').then(m => m.SignupComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.routes').then(m => m.pagesRoutes)
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.routes').then(m => m.settingsRoutes)
  },
  {
    path: 'account-recovery',
    loadChildren: () => import('./authentication/account-recovery/account-recovery.routes').then(m => m.accountRecoveryRoutes)
  },
  {
    path: 'shop',
    loadComponent: () => import('./shop/shop.component').then(m => m.ShopComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    canActivateChild: [maintenanceGuard],
    resolve: {
      data: productsResolver
    }
  },
  {
    path: 'shop/custom-box/:bundleEditionType/:productId',
    title: 'Shop Custom Box',
    loadComponent: () => import('./shared/custom-box/custom-box.component').then(m => m.CustomBoxComponent),
    pathMatch: 'full',
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'shop/:category',
    loadComponent: () => import('./shop/shop.component').then(m => m.ShopComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    resolve: {
      data: productsResolver
    }
  },
  {
    path: 'shop/:category/:subcategory',
    loadComponent: () => import('./shop/shop.component').then(m => m.ShopComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    resolve: {
      data: productsResolver
    }
  },
  // This route is used for both, product detail or subcategory son navigation:
  {
    path: 'shop/:category/:subcategory/:slug',
    loadComponent: () => import('./shop/shop-or-product/shop-or-product.component').then(m => m.ShopOrProductComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    resolve: {
      data: productsResolver
    }
  },
  {
    path: 'favorites',
    title: 'Favorites',
    loadComponent: () => import('./fav-products/fav-products.component').then(m => m.FavProductsComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions]
  },
  {
    path: 'buy-again',
    title: 'Buy again',
    loadComponent: () => import('./buy-again-products/buy-again-products.component').then(m => m.BuyAgainProductsComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions]
  },
  {
    path: 'order',
    title: 'Order',
    loadComponent: () => import('./side-checkout/side-checkout.component').then(m => m.SideCheckoutComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions]
  },
  {
    path: 'terms-and-conditions',
    title: 'Terms & Conditions',
    loadComponent: () => import('./authentication/signup/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: 'order/custom-box/:bundleEditionType',
    title: 'Order Custom Box',
    loadComponent: () => import('./shared/custom-box/custom-box.component').then(m => m.CustomBoxComponent),
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'order/custom-box/:bundleEditionType/:productId',
    title: 'Order Custom Box',
    loadComponent: () => import('./shared/custom-box/custom-box.component').then(m => m.CustomBoxComponent),
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'product/custom-box/:bundleEditionType/:productId',
    title: 'Product Custom Box',
    loadComponent: () => import('./shared/custom-box/custom-box.component').then(m => m.CustomBoxComponent),
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'signup/custom-box/:bundleEditionType/:productId',
    title: 'Sign Up Custom Box',
    loadComponent: () => import('./shared/custom-box/custom-box.component').then(m => m.CustomBoxComponent),
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  // {
  //   path: 'welcome',
  //   title: 'Welcome',
  //   component: WelcomeComponent,
  //   canActivate: [maintenanceGuard, hasSession]
  // },
  {
    path: '**',
    redirectTo: ''
  }
];
